import ApiService from '../api.service';

const PriceTableResource = {
  indexPriceTable: (params) => ApiService.query('/v1/price_table', params),
};

export default PriceTableResource;
